<template>
    <account :params="params">
        <a-tab v-for="(tab, i) in params.tabs" :key="i" :name="params.tabs[i].name">
            <template v-if="params.tabs[i].name === 'about'">
                <div class="account__content">
                    <a-video v-if="params.video" :src="params.video.src" :cover="params.video.cover"/>
                    <user-description :description="params.user.description" :social="params.user.social" />
                    <div class="account__body-section" v-if="params.about">
                        <h3>О специалисте</h3>
                        <div class="content" v-html="params.about"></div>
                    </div>
                    <div class="account__body-section" v-if="params.files.length > 0">
                        <h3>Полезная информация</h3>
                        <user-files :items="params.files">
                            <template #actions="{item}">
                                <a :href="item.url" download="">Скачать</a>
                            </template>
                        </user-files>
                    </div>
                </div>
            </template>
            <template v-else-if="params.tabs[i].name === 'projects'">
                <div class="account__body-section-title flex v-center">
                    <h3 class="nomargin">Участие в проектах</h3>
                    <a-badge>{{ params.projects.total }}</a-badge>
                </div>
                <div class="account__projects" v-if="projects.length > 0">
                    <user-project-card v-for="(project, i) in projects" :key="i" v-bind="project" />
                    <a-btn
                        v-if="params.reviews.total > projects.length"
                        label="Показать еще"
                        class="dark d12"
                        fill="outlined"
                        @click="projectsLoadMore"
                    />
                </div>
            </template>
            <template v-else-if="params.tabs[i].name === 'reviews'">
                <div class="account__body-section-title flex v-center">
                    <h3 class="nomargin">Отзывы</h3>
                    <a-badge>{{ params.reviews.total }}</a-badge>
                </div>
                <div class="account__reviews" v-if="reviews.length > 0">
                    <user-review-card v-for="(review, i) in reviews" :key="i" v-bind="review" />
                    <a-btn
                        v-if="params.reviews.total >= reviews.length"
                        label="Показать еще"
                        class="dark d12"
                        fill="outlined"
                        @click="reviewsLoadMore"
                    />
                </div>
            </template>
        </a-tab>
        <template #aside>
            <account-card v-bind="params.user">
                <template #actions>
                    <a-btn label="Добавить в избранное" fill="flat" @click="toggleFavorite" />
                    <a-btn label="Связаться со специалистом" class="secondary" @click="feedback"/>
                </template>
            </account-card>
            <user-description :description="params.user.description" :social="params.user.social" />
        </template>
    </account>
</template>

<script>

import { ref } from 'vue'
import Account from './Account.vue'
import AccountCard from '../cards/AccountCard.vue'
import { ATab, ABtn, ABadge, AVideo } from '../ui'
import UserProjectCard from '../cards/UserProjectCard.vue'
import UserReviewCard from '../cards/UserReviewCard.vue'
import UserFiles from '../cards/UserFiles.vue'
import UserDescription from '../cards/UserDescription.vue'


import { volonterProjectsLoadMore, volonterReviewsLoadMore } from '../../services/api'

export default {
    name: 'AccountVolonter',
    components: {
        Account,
        AccountCard,
        ATab,
        ABtn,
        ABadge,
        UserProjectCard,
        UserReviewCard,
        UserFiles,
        UserDescription,
        AVideo,
    },
    props: ['params'],
    setup: (props, ctx) => {

        const reviews = ref(props.params.reviews.items)
        const projects = ref(props.params.projects.items)

        const projectsLoadMore = async () => {
            const response = await volonterProjectsLoadMore({id: props.params.user.id})
            projects.value = [...projects.value, ...response.data]
        }

        const reviewsLoadMore = async () => {
            const response = await volonterReviewsLoadMore({id: props.params.user.id})
            reviews.value = [...reviews.value, ...response.data]
        }

        const feedback = () => {
            console.log('feedback')
        }

        const toggleFavorite = () => {
            console.log('Toggle favorite')
        }
        
        return {
            projects,
            reviews,
            projectsLoadMore,
            reviewsLoadMore,
            toggleFavorite,
            feedback,
        }
    },
}
</script>

<style lang="scss">

</style>